// extracted by mini-css-extract-plugin
export default {"welcome__container":"Welcome_welcome__container__RWdbc"};